<main>
  @if (!showDetails) {
    <div class="container">
      <div class="topheadtitle">
        <h4>eCitation Status Search</h4>
      </div>
      @if (!showReportResults) {
        <div class="form-box">
          <div class="formPage">
            <form [formGroup]="searchForm">
              <label class="fw-600" for="citationNumber" style="margin-right: 13px;">Citation number</label>
              <input formControlName="citationNumber" id="citationNumber" type="text" placement="top"
                triggers="mouseenter:mouseleave"
                ngbPopover="A minimum of 1 initial character entry is needed for a specific citation search"
                class="Input-width" />
                <span class="text-para" style="margin: 0 28px 0 10px;">
                  Alphanumeric Characters only - please do not include the information <i>after</i> the dash
                </span>
                <label class="fw-600" for="issuedBy" style="margin-right: 5px;">Issued By</label>
                <select id="issuedBy" formControlName="issuedBy" class="option-d">
                  <option value="ALL">All</option>
                  <option value="Not Specified">Not Specified</option>
                  @for (item of agenciesList; track item) {
                    <option [value]="item.agencyName">{{ item.agencyName }}</option>
                  }
                </select>
                <hr />
                <div class="box-date">
                  <!-- Transmission Date -->
                  <div aria-labelledby="txdate-legend" aria-describedby="txdate-hint">
                    <span id="txdate-legend" class="fw-600">Transmission Date</span>
                    <input type="date" [max]="today" formControlName="transmissionStartDate" class="Input-width"
                      aria-describedby="txdate-hint" aria-labelledby="txdate-legend" />
                      <span aria-hidden="true"> to </span>
                      <input type="date" [max]="today" formControlName="transmissionEndDate" class="Input-width"
                        aria-describedby="txdate-hint" aria-labelledby="txdate-legend" />
                        <span id="txdate-hint" class="text-para">Enter just beginning date or end date if a single
                        date</span><br />
                      </div>
                      <!-- Court Date -->
                      <div aria-labelledby="courtdate-legend" aria-describedby="courtdate-hint">
                        <span id="courtdate-legend" class="fw-600">Court Date</span>
                        <input type="date" [max]="today" formControlName="courtStartDate" class="Input-width"
                          aria-describedby="courtdate-hint" aria-labelledby="courtdate-legend" />
                          <span aria-hidden="true"> to </span>
                          <input type="date" [max]="today" formControlName="courtEndDate" class="Input-width"
                            aria-describedby="courtdate-hint" aria-labelledby="courtdate-legend" />
                            <span id="courtdate-hint" class="text-para">instead of a date range is wanted.</span><br />
                          </div>
                          <!-- Violation Date -->
                          <div aria-labelledby="violationdate-legend">
                            <span id="violationdate-legend" class="fw-600">Violation Date</span>
                            <input type="date" [max]="today" formControlName="violationStartDate" class="Input-width"
                              aria-labelledby="violationdate-legend" />
                              <span aria-hidden="true"> to </span>
                              <input type="date" [max]="today" formControlName="violationEndDate" class="Input-width"
                                aria-labelledby="violationdate-legend" /><br />
                              </div>
                              <!-- Served Date -->
                              <div aria-labelledby="serveddate-legend">
                                <span id="serveddate-legend" class="fw-600">Served Date</span>
                                <input type="date" [max]="today" formControlName="servedStartDate" class="Input-width"
                                  aria-labelledby="serveddate-legend" />
                                  <span aria-hidden="true"> to </span>
                                  <input type="date" [max]="today" formControlName="servedEndDate" class="Input-width"
                                    aria-labelledby="serveddate-legend" />
                                  </div>
                                </div>
                                <hr />
                                <div class="destination">
                                  <label class="fw-600" for="destination" style="margin: 0 45px 0 0;">Destination</label>
                                  <select id="destination" formControlName="destination" multiple size="6" aria-label="Destination">
                                    <option value="ALL">All</option>
                                    <option value="DAIT-Protect">DAIT-Protect</option>
                                    <option value="COWS">COWS</option>
                                    <option value="CCAP">CCAP</option>
                                    <option value="Municipal Court">Municipal Court</option>
                                    <option value="DOT EARS Service">DOT EARS Service</option>
                                    <option value="DNR CTS Service">DNR CTS Service</option>
                                    <option value="Void and Local">Void and Local</option>
                                  </select>
                                  <label class="fw-600" for="status" style="margin: 0 19px 0 85px;">Status</label>
                                  <select id="status" formControlName="status" multiple aria-label="Status">
                                    <option value="ALL">All</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Failed">Failed</option>
                                    <option value="Queued">Queued</option>
                                  </select>
                                </div>
                                <hr />
                                <label class="fw-600" for="sortBy" style="margin-right: 69px;">Sort By</label>
                                <select formControlName="sortBy" id="sortBy">
                                  <option value="Citation Number">Citation Number</option>
                                  <option value="Transmission Date">Transmission Date</option>
                                </select>
                                <hr />
                                <div class="formpage-btn">
                                  <button type="submit" class="btn-Submit" (click)="onSearch()">Search</button>
                                  <button type="button" class="btn-Submit" (click)="resetForm()">Reset</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        }
                        @if (showReportResults) {
                          <div>
                            @if (alert) {
                              <div class="alert alert-success my-2" role="alert" aria-live="polite">{{ alert.message }}</div>
                            }
                            <!-- Tabs -->
                            <ul class="nav nav-tabs" role="tablist">
                              <li class="nav-item" (click)="activeTab = 1">
                                <a href="javascript:void(0)" id="Status" class="nav-link" [ngClass]="activeTab == 1 ? 'active' : ''"
                                  role="tab" [attr.aria-selected]="activeTab == 1">
                                  Status
                                </a>
                              </li>
                              <li class="nav-item" (click)="activeTab = 2">
                                <button
                                  type="button" id="Details" class="nav-link" [ngClass]="activeTab == 2 ? 'active' : ''"
                                  role="tab" [attr.aria-selected]="activeTab == 2">
                                  Details
                                </button>
                              </li>
                            </ul>
                            <div class="table-container mt-2">
                              <div class="btn-group mb-2">
                                <button type="button" class="btn btn-outline-primary" (click)="resendSelected()">Resend</button>
                                @if (authType.menuType === 'ROLE_ADMIN' && userTypeView === 'S') {
                                  <button type="button"
                                    class="btn btn-outline-primary" (click)="deleteSelected()">
                                    Delete
                                  </button>
                                }
                              </div>
                              <table class="table">
                                <caption>eCitation Status Search Results</caption>
                                <thead>
                                  <tr>
                                    <th scope="col"></th>
                                    <th scope="col">
                                      <span role="button" tabindex="0" (click)="onSort($event,'citationNumber',true)"
                                        (keydown.enter)="onSort($event,'citationNumber',true)"
                                        (keydown.space)="onSort($event,'citationNumber',true)"
                                        aria-label="Sort by Citation Number">
                                        Citation Number <i class="fa fa-sort" aria-hidden="true"></i>
                                      </span>
                                    </th>
                                    @if (activeTab == 1) {
                                      <th scope="col">
                                        <span role="button" tabindex="0" (click)="onSort($event,'agencyName',true)"
                                          (keydown.enter)="onSort($event,'agencyName',true)"
                                          (keydown.space)="onSort($event,'agencyName',true)" aria-label="Sort by Issued By">
                                          Issued By <i class="fa fa-sort" aria-hidden="true"></i>
                                        </span>
                                      </th>
                                    }
                                    <th scope="col">
                                      <span role="button" tabindex="0" (click)="onSort($event,'transmissionDate',true)"
                                        (keydown.enter)="onSort($event,'transmissionDate',true)"
                                        (keydown.space)="onSort($event,'transmissionDate',true)"
                                        aria-label="Sort by Transmitted">
                                        Transmitted <i class="fa fa-sort" aria-hidden="true"></i>
                                      </span>
                                    </th>
                                    @if (activeTab == 1) {
                                      <th scope="col">
                                        <span role="button" tabindex="0" (click)="onSort($event,'disposition',true)"
                                          (keydown.enter)="onSort($event,'disposition',true)"
                                          (keydown.space)="onSort($event,'disposition',true)" aria-label="Sort by Disposition">
                                          Disposition <i class="fa fa-sort" aria-hidden="true"></i>
                                        </span>
                                      </th>
                                    }
                                    @if (activeTab == 1) {
                                      <th scope="col">
                                        <span role="button" tabindex="0" (click)="onSort($event,'destinationName',true)"
                                          (keydown.enter)="onSort($event,'destinationName',true)"
                                          (keydown.space)="onSort($event,'destinationName',true)"
                                          aria-label="Sort by Destination">
                                          Destination <i class="fa fa-sort" aria-hidden="true"></i>
                                        </span>
                                      </th>
                                    }
                                    @if (activeTab == 1) {
                                      <th scope="col">Status</th>
                                    }
                                    @if (activeTab == 2) {
                                      <th scope="col">
                                        <span role="button" tabindex="0" (click)="onSort($event,'courtDate',true)"
                                          (keydown.enter)="onSort($event,'courtDate',true)"
                                          (keydown.space)="onSort($event,'courtDate',true)" aria-label="Sort by Court">
                                          Court <i class="fa fa-sort" aria-hidden="true"></i>
                                        </span>
                                      </th>
                                    }
                                    @if (activeTab == 2) {
                                      <th scope="col">Violation</th>
                                    }
                                    @if (activeTab == 2) {
                                      <th scope="col">Served</th>
                                    }
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (item of getItems(); track item; let i = $index) {
                                    <tr>
                                      <td>
                                        <input type="checkbox" aria-label="select citation" id="{{item.id}}"
                                          [checked]="isSelected(item)" (change)="toggleSelection(item)" />
                                        </td>
                                        <td>
                                          {{ item.citationNumber }}
                                          <button class="btn btn-sm btn-link p-0 ml-2 table-link" type="button"
                                          (click)="viewXml(item, xmlModal)">View XML</button>
                                        </td>
                                        @if (activeTab == 1) {
                                          <td>{{ item.agencyName }}</td>
                                        }
                                        <td>{{ item.transmissionDate }}</td>
                                        @if (activeTab == 1) {
                                          <td>{{ item.disposition }}</td>
                                        }
                                        @if (activeTab == 1) {
                                          <td>
                                            @switch (item.destinationName) {
                                              @case ('DOT-EARS') {
                                                <span>EARS</span>
                                              }
                                              @case ('CCAP-DOT') {
                                                <span>CCAP</span>
                                              }
                                              @case ('CCAP-DNR') {
                                                <span>CCAP</span>
                                              }
                                              @case ('DOT-COWS') {
                                                <span>COWS</span>
                                              }
                                              @case ('MUNI') {
                                                <span>MUNI</span>
                                              }
                                              @case ('DAIT-PROTECT') {
                                                <span>DAIT-PROTECT</span>
                                              }
                                              @case ('DNR-CTS') {
                                                <span>CTS</span>
                                              }
                                              @case ('NOWHERE') {
                                                <span>LOCAL</span>
                                              }
                                              @default {
                                                <span>-</span>
                                              }
                                            }
                                          </td>
                                        }
                                        @if (activeTab == 1) {
                                          <td>
                                            <button type="button" class="btn btn-link p-0 details" (click)="showDetaislStatus(item)">
                                              {{ details[item.status] }}
                                            </button>
                                          </td>
                                        }
                                        @if (activeTab == 2) {
                                          <td>{{ item.courtDate }}</td>
                                        }
                                        @if (activeTab == 2) {
                                          <td>{{ item.violationDate }}</td>
                                        }
                                        @if (activeTab == 2) {
                                          <td>{{ item.servedDate }}</td>
                                        }
                                      </tr>
                                    }
                                    @if (outPut.content.length == 0) {
                                      <tr>
                                        <td colspan="10">No records found</td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                                <div class="text-center">{{ searchQuery() }}</div>
                                <div class="d-flex justify-content-between align-items-center">
                                  <div>
                                    <span>
                                      {{ outPut.totalElements }} items found, displaying {{ getCurrentPageTotal() }} of {{
                                      outPut.totalElements }}
                                    </span>
                                  </div>
                                  <ngb-pagination [collectionSize]="outPut.totalElements" [(page)]="currentPage" [ellipses]="true"
                                    [maxSize]="10" (pageChange)="onPageChange(currentPage)" [pageSize]="pageSize" [boundaryLinks]="true"
                                  aria-label="Results pagination"></ngb-pagination>
                                  <button type="button" class="btn btn-outline-primary"
                                    (click)="showReportResults = false; activeTab = 1; selectedItems = []; currentPage = 1; resetForm();">
                                    Go back to previous page
                                  </button>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }

                      @if (showDetails) {
                        <div class="container">
                          <div class="topheadtitle">
                            <h4>Delivery Report for Citation - {{ selectedValue[0].citationNumber }}</h4>
                          </div>
                          @for (item of selectedValue; track item; let i = $index) {
                            <div class="py-3">
                              <div class="compAccentBarBot" style="height:1.2em"></div>
                              <table class="searchInputBox2 accessible-caption"
                                summary="Delivery Report for Citation - {{selectedValue[0].citationNumber}} - {{i}}">
                                @if (i === selectedValue.length - 1) {
                                  <caption>
                                    Delivery Report for Citation - {{ selectedValue[0].citationNumber }}
                                  </caption>
                                }
                                <tbody>
                                  <tr>
                                    <th scope="row" class="formFieldLabel">System:</th>
                                    <td class="formField">{{ item.destinationName }}</td>
                                    <th scope="row" class="formFieldLabel">Form Number:</th>
                                    <td class="formField">{{ item.citationNumber }}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row" class="formFieldLabel">Product Name:</th>
                                    <td class="formField">{{ item.productName }}</td>
                                    <th scope="row" class="formFieldLabel">Product Date Time:</th>
                                    <td class="formField">{{ item.transmissionDate }}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row" class="formFieldLabel">Message:</th>
                                    <td class="formField" colspan="3">{{ details[item.status] }}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="compAccentBarBot" style="height:1.2em"></div>
                            </div>
                          }
                          <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-outline-primary" (click)="showDetails = false;">Go back to previous
                            page</button>
                          </div>
                        </div>
                      }

                      <!-- XML Modal Template -->
                      <ng-template #xmlModal let-modal>
                        <div class="modal-dialog modal-lg modal-dialog-scrollable">
                          <div class="modal-content">
                            <div class="modal-header bg-light">
                              <h5 class="modal-title text-dark">Citation XML: {{ selectedCitation }}</h5>

                              <button type="button" class="btn btn-sm btn-secondary me-2" (click)="copyXmlContent()">
                                <i class="fa fa-copy" [class.text-success]="copySuccess" [class.text-danger]="copyError"
                                aria-hidden="true"></i>
                                <span class="visually-hidden">Copy XML</span>
                              </button>

                              <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
                            </div>

                            <div class="modal-body p-2">
                              <pre class="xml-content"><code [innerText]="xmlContent"></code></pre>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </main>